/**
 * @generated SignedSource<<5f6808a14c348ae3ad42173648cc194f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type StatusUiPermissionEnum = "PUBLIC" | "RESTRICTED";
export type ZnglistTemplateTypeEnum = "CLASSIC" | "PENDING" | "PERSONAL";
export type ZnglistUserTypeEnum = "ADMIN" | "USER";
export type CreateZnglistInput = {
  authorId?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  date?: string | null | undefined;
  formId?: string | null | undefined;
  menuOrder?: number | null | undefined;
  order?: number | null | undefined;
  password?: string | null | undefined;
  slug?: string | null | undefined;
  status?: PostStatusEnum | null | undefined;
  statusSettings?: StatusSettingsInput | null | undefined;
  templateType?: ZnglistTemplateTypeEnum | null | undefined;
  title?: string | null | undefined;
  userType?: ZnglistUserTypeEnum | null | undefined;
  znglyContents?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type StatusSettingsInput = {
  approved?: ApprovedStateInput | null | undefined;
  stateWhenApproved?: StateWhenApprovedInput | null | undefined;
  status?: PostStatusEnum | null | undefined;
  uiPermission?: UIPermissionInput | null | undefined;
};
export type ApprovedStateInput = {
  id?: string | null | undefined;
};
export type StateWhenApprovedInput = {
  status?: PostStatusEnum | null | undefined;
  uiPermission?: UIPermissionInput | null | undefined;
};
export type UIPermissionInput = {
  type?: StatusUiPermissionEnum | null | undefined;
};
export type Znglist_Create_Mutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateZnglistInput;
};
export type Znglist_Create_Mutation$data = {
  readonly createZnglist: {
    readonly znglist: {
      readonly author: {
        readonly node: {
          readonly id: string;
          readonly name: string | null | undefined;
          readonly slug: string | null | undefined;
          readonly username: string | null | undefined;
        };
      } | null | undefined;
      readonly date: string | null | undefined;
      readonly id: string;
      readonly modified: string | null | undefined;
      readonly status: string | null | undefined;
      readonly title: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type Znglist_Create_Mutation = {
  response: Znglist_Create_Mutation$data;
  variables: Znglist_Create_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Znglist",
  "kind": "LinkedField",
  "name": "znglist",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NodeWithAuthorToUserConnectionEdge",
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "username",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "Znglist_Create_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreateZnglistPayload",
        "kind": "LinkedField",
        "name": "createZnglist",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "Znglist_Create_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreateZnglistPayload",
        "kind": "LinkedField",
        "name": "createZnglist",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "znglist",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "Znglist"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b9f4b4c7084b1a761b50a186e71925f8",
    "id": null,
    "metadata": {},
    "name": "Znglist_Create_Mutation",
    "operationKind": "mutation",
    "text": "mutation Znglist_Create_Mutation(\n  $input: CreateZnglistInput!\n) {\n  createZnglist(input: $input) {\n    znglist {\n      id\n      title\n      status\n      date\n      modified\n      author {\n        node {\n          id\n          name\n          username\n          slug\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2e75b04b7ed3ab8fb305f8b765da300b";

export default node;
